import type { SuggestedSalary } from 'src/types/salaryTypes';

type SalaryJudgementEnum = 'NONE' | 'LOW' | 'GOOD' | 'TOO_HIGH';

export interface Parameters {
  hasValidationError: boolean;
  minimumSalary?: number | null;
  maximumSalary?: number | null;
  suggestedSalary: SuggestedSalary | null;
}

export const judgeSalaryRange = ({
  hasValidationError,
  minimumSalary,
  maximumSalary,
  suggestedSalary,
}: Parameters): SalaryJudgementEnum => {
  const min = minimumSalary ?? 0;
  const max = maximumSalary ?? 0;
  if (!suggestedSalary || hasValidationError) {
    return 'NONE';
  } else if (suggestedSalary.averageMax * 2 < min) {
    return 'TOO_HIGH';
  } else if (
    min < suggestedSalary.averageMin &&
    max < suggestedSalary.averageMin
  ) {
    return 'LOW';
  }
  return 'GOOD';
};
